import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { DiffTool } from "../components/DiffTool";
import { TdBreadcrumb } from "../components/TdBreadcrumb";
import { TdExplainer } from "../components/TdExplainer";

export function TextDiffPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <TdBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.td_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.td_intro()}
          </p>
        </header>

        <DiffTool />

        <TdExplainer
          howTo={m.td_howto()}
          faqs={[
            { q: m.td_faq1_q(), a: m.td_faq1_a() },
            { q: m.td_faq2_q(), a: m.td_faq2_a() },
            { q: m.td_faq3_q(), a: m.td_faq3_a() },
            { q: m.td_faq4_q(), a: m.td_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
